// import React from "react";

// const Section05 = () => {
//   return (
//     <>
//       <section className="banner-section-3  pb-5 pt-2">
//         <img
//           src="images/banner/secondbanner.png"
//           alt="Banner"
//           className="max-w-full h-auto"
//         />
//       </section>
//     </>
//   );
// };

// export default Section05;

import React from "react";

const Section05 = () => {
  return (
    <section className="banner-section-3   container">
      <video className="py-14 " width="100%" height="500" autoPlay muted loop>
        <source
          src="images/orin-star-promo.mp4"
          type="video/mp4"
          className="!rounded-xl"
        />
        Your browser does not support the video.
      </video>
    </section>
  );
};

export default Section05;
